export const FlowStatus = {
  LOADING: "LOADING",
  LOADED: "LOADED",
  ERROR: "ERROR"
};
